import { render, staticRenderFns } from "./platformOrder.vue?vue&type=template&id=9a888692&scoped=true"
import script from "./platformOrder.vue?vue&type=script&lang=js"
export * from "./platformOrder.vue?vue&type=script&lang=js"
import style0 from "./platformOrder.vue?vue&type=style&index=0&id=9a888692&prod&lang=less"
import style1 from "./platformOrder.vue?vue&type=style&index=1&id=9a888692&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a888692",
  null
  
)

export default component.exports